export default "__VITE_ASSET__odF7_VMX__"